<template>
  <div>
    <strong style="font-size: 150%">Facturación</strong>
    <b-row style="padding-top: 40px">
      <b-col cols="3">
        <label class="mt-3 mb-3" for="gastoDesplazamientoCosteCheck" strong
          >Gasto Coste Desplazamiento</label
        >
      </b-col>
      <b-col cols="1" class="mt-3 mb-3">
        <input
          type="checkbox"
          class="custom-checkbox"
          v-model="gastoDesplazamientoCosteCheck"
          @change="seleccionarCheckboxDesplazamiento"
        />
      </b-col>
      <b-col cols="2">
      <label class="mt-3 mb-3" for="costeBonificacionCheck" strong
          >Coste Certificados</label
        >
      </b-col>
    
      <b-col cols="1" class="mt-3 mb-3">
        <input
          type="checkbox"
          class="custom-checkbox"
          v-model="gastoCertificadoCheck"
          @change="seleccionarCheckboxCertificado"
        />
      </b-col>
      <b-col cols="2">
        <label class="mt-3 mb-3" for="costeBonificacionCheck" strong
          >Coste Bonificacion</label
        >
      </b-col>
      <b-col cols="1" class="mt-3 mb-3">
        <input
          type="checkbox"
          class="custom-checkbox"
          v-model="costeBonificacionCheck"
          @change="seleccionarCheckboxBonificacion"
        />
      </b-col>
      
    </b-row>
    <b-row class="mt-5 mb-3">
      <b-col cols="3">
        <label for="hitoFacturacion" style=" margin-left: -10px; font-weight: bold; color: green;" class="form-label">Hito Facturación</label>
        <b-form-select size="sm" v-model="hitoFacturacion" style=" margin-left: -10px;">
          <option value=""></option>
          <option value="2.5">2.5 %</option>
          <option value="5">5 %</option>
          <option value="7.5">7.5 %</option>
          <option value="10">10 %</option>
          <option value="15">15 %</option>
          <option value="20">20 %</option>
          <option value="25">25 %</option>
          <option value="30">30 %</option>
          <option value="35">35 %</option>
          <option value="40">40 %</option>
          <option value="50">50 %</option>
          <option value="60">60 %</option>
          <option value="65">65 %</option>
          <option value="70">70 %</option>
          <option value="80">80 %</option>
          <option value="90">90 %</option>
          <option value="100">100 %</option>
          <option value="Bonificacion">Coste Bonificacion</option>
          <option value="Formacion/Sesion">Formación/Sesión</option>
          <option value="Abono">Abono</option>
          <option value="Desplazamiento">Coste Desplazamiento</option>
          <option value="Certificacion">Coste Certificacion</option>
          <option value="Consultoria/horas">Consultoría por Horas</option>
          <option value="CosteImpresion">Coste Impresión</option>
          <option value="AjusteFacturacion">Ajuste Facturación</option>
          
         
        </b-form-select>
      </b-col>

      <b-col>
        <label for="gastoViajeCoste" style=" margin-left: -10px;" class="form-label">Desplazamiento</label>
        <b-form-input
          style="font-size: 80%; margin-left: -10px;"
          v-model="gastoViajeCoste"
          id="gastoViajeCoste"
        ></b-form-input>
      </b-col>
      <b-col>
        <label for="gastoViajeCoste" style=" margin-left: -10px;" class="form-label">Impresión</label>
        <b-form-input
        style="font-size: 80%; margin-left: -10px;"
          v-model="impresion"
          id="impresion"
        ></b-form-input>
      </b-col>
      <b-col>
        <label for="gastoViajeCoste" style=" margin-left: -10px;" class="form-label">Bonificacion</label>
        <b-form-input
        style="font-size: 80%; margin-left: -10px;"
          v-model="gastoBonificacion"
          id="gastoBonificacion"
        ></b-form-input>
      </b-col>
      <b-col>
        <label for="gastoCertificado" style=" margin-left: -10px;" class="form-label">Certificación</label>
        <b-form-input
        style="font-size: 80%; margin-left: -10px;"
          v-model="gastoCertificado"
          id="gastoCertificado"
        ></b-form-input>
      </b-col>
    </b-row>
    <b-row class=" mb-5">
      <b-col>
        <label for="importeConsultoriaHoras" class="form-label"
          >Consultoría_Horas</label
        >
        <b-form-input
        style="font-size: 80%; margin-left: -10px;"
          v-model="importeConsultoriaHoras"
          id="importeConsultoriaHoras"
        ></b-form-input>
      </b-col>
      <b-col>
        <label for="abono" style=" margin-left: -10px;" class="form-label">Abono</label>
        <b-form-input
        style="font-size: 80%; margin-left: -10px;"
          v-model="abono"
          id="abono"
        ></b-form-input>
      </b-col>
      <b-col>
        <label for="gastoCertificado" style=" margin-left: -10px;" class="form-label">Formación/Sesión</label>
        <b-form-input
        style="font-size: 80%; margin-left: -10px;"
          v-model="formacionSesion"
          id="formacionSesion"
        ></b-form-input>
      </b-col>
      <b-col>
        <label for="AjusteFacturacion" style=" margin-left: -10px;" class="form-label">Ajuste Facturación</label>
        <b-form-input
        style="font-size: 80%; margin-left: -10px;"
          v-model="importeAjusteFacturacion"
          id="AjusteFacturacion"
        ></b-form-input>
      </b-col>
      <b-col cols="1" style="padding: 29px 0px 0px 0px">
  <b-button
  :disabled=" !['ROLE_SUPERADMIN', 'ROLE_FINANCE','ROLE_SALES','ROLE_MANAGER','ROLE_TRAINING'].includes(currentUser.roles[0]) && nombreEmpleado != propietarioNombre"
    variant="success"
    class="actionButton"
    @click="addLineStopCriteria()"
  >+</b-button>
</b-col>

    </b-row>
    <b-row>
      <b-col>
        <b-table
          style="font-size: 90%"
          class="shadow-sm vertical-center mt-2 text-center"
          responsive
          id="stopCriterias"
          :fields="camposHitosFacturacion"
          :items="hitosFacturacionOrdenados"
          bordered
          hover
          small
        
        >
   
          <template #cell(facturarConsultor)="row" text-center>
            <td class="d-flex justify-content-center align-items-center "   style="background:rgb(228, 245, 229);">
              <input
             :disabled="cuasiPedido"
                style="width: 20px; height: 20px; background: rgb(241, 239, 212)"
                type="checkbox"
                :checked="row.item.facturarConsultor"
                @change="updateFacturarConsultor(row.item)"
              />
            </td>
          </template>
          <template
            #cell(hitoFacturado)="row"
            text-center
          
          >
            <td class="d-flex justify-content-center align-items-center">
              <input
                type="checkbox"
                class="custom-checkbox"
                :checked="row.item.hitoFacturado"
                @change="updateFacturado(row.item)"
                  :disabled=" !['ROLE_SUPERADMIN', 'ROLE_FINANCE'].includes(currentUser.roles[0])"
              />
            </td>
          </template>
          <template #cell(fechaOKConsultor)="row"
          
           text-center>
            <b-input
              style="background:rgb(228, 245, 229);"
              type="date"
              class="form-label"
              size="sm"
              v-model="row.item.fechaOKConsultor"
              id="fechaOKConsultor"
            ></b-input>
          </template>
          <template #cell(liquidarNumeroDocumento)="row"
          
          >
  <td v-if="row.item.hitoFacturacion === 'Abono'" class="text-center">
    <b-form-select
    :disabled=" !['ROLE_SUPERADMIN', 'ROLE_FINANCE'].includes(currentUser.roles[0])"
      size="sm"
      v-model="row.item.liquidarNumeroDocumento"
      :options="facturasDisponibles"
      placeholder="Selecciona factura"
    ></b-form-select>
  </td>
</template>

          <template
            #cell(fechaFacturado)="row"
            text-center
          
          >
            <b-input
             
              type="date"
              class="form-label"
              size="sm"
              v-model="row.item.fechaFacturado"
              id="fechaFacturado"
               :disabled=" !['ROLE_SUPERADMIN', 'ROLE_FINANCE'].includes(currentUser.roles[0])"
            ></b-input>
          </template>

          <template #cell(importeHito)="row" text-center>
  <b-form-input
    class="form-label"
    size="sm"
    v-model="row.item.importeHito"
    id="importeHito"
    :disabled="!(row.item.hitoFacturacion === 'AjusteFacturacion' && isAdminOrSuperAdmin)"
  ></b-form-input>
</template>




          <template #cell(action)="row" align="center">
          <b-button-group>
            <b-button
            v-if="!row.item.observacion || row.item.observacion === ''"
                  class="actionButton mr-2"
                  variant="outline-primary"
                  v-b-modal.modal-observaciones
                  @click="abrirObservacion(row.item)"
                ><i class="fas fa-comment-dots"></i></b-button>
                <b-button
          v-else
                  class="actionButton mr-2"
                  variant="outline-danger"
                  v-b-modal.modal-observaciones
                  @click="abrirObservacion(row.item)"
                ><i class="fas fa-comment-dots"></i></b-button>
            <b-button
            :disabled=" !['ROLE_SUPERADMIN', 'ROLE_FINANCE','ROLE_SALES','ROLE_TRAINING','ROLE_MANAGER'].includes(currentUser.roles[0])"
              size="sm"
              class="actionButton"
              variant="outline-danger"
              @click="deleteLineStopCriteria(row)"
              ><i class="fas fa-trash-alt"></i
            ></b-button>
          </b-button-group>
          </template>

<template #cell(numFactura)="row">
  <td class="d-flex justify-content-center align-items-center">
    <b-form-input
      :style="{
        backgroundColor:
          row.item.facturaCobrada === 'Cobrada'
            ? '#d4edda'
            : row.item.facturaCobrada === 'Parcialmente cobrada'
            ? '#fff3cd'
            : row.item.facturaCobrada === 'Pendiente'
            ? '#f8d7da'
            : 'white'
      }"
      v-model="row.item.numFactura"
      id="numFactura"
      style="text-align: center;"
      :readonly="!['ROLE_FINANCE', 'ROLE_SUPERADMIN'].includes(currentUser.roles[0])"
      @change=" updatefacturacionConsultorPorcentaje(row.item)"
    />
  </td>
</template>



        </b-table>
      </b-col>
    </b-row>
    <b-modal
      id="modal-observaciones"
      title="Observaciones "
      ok-variant="primary"
      ok-title="Guardar"
      cancel-title="Cancelar"
      footer-class="p-2"
      :centered="true"
    >
      <label for="observaciones" class="form-label">Observaciones</label>
      <b-form-textarea 
        v-model="item_observacion.observacion"
      />
    </b-modal>
  
  </div>
</template>

<script>
import { api1 } from "@/lib/http";

export default {
  name: "HitosFacturacion",
  props: {
    importeItem: { type: Number, required: true },
    propietarioNombre: { type: String, required: true },
    cuasiPedido: { type: Boolean, required: true },
  },
  data() {
    return {
      facturaCobrada: "",
      item_observacion: { observacion: "" },
      hitoFacturacion: "",
      importeHito: "",
      facturarConsultor: false,
      fechaOKConsultor: "",
      hitoFacturado: false,
      fechaFacturado: "",
      numFactura: "",
      hitosFacturacion: [],
      abono: 0,
      gastoViajeCoste: 0,
      gastoCertificado: 0,
      gastoBonificacion: 0,
      totalProvisionado: 0,
      totalFacturado: 0,
      gastoDesplazamientoCosteCheck: false,
      gastoCertificadoCheck: false,
      costeBonificacionCheck: false,
      importeConsultoriaHoras: 0,
      importeAjusteFacturacion: 0,
      impresion: 0,
      formacionSesion: 0,
      usuario: "",
      nombreEmpleado: "",
      liquidarNumeroDocumento: "",
    };
  },
  methods: {
    getEmpleadoByUsername() {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user?.username) return;

      api1
        .get(`/api/dekra/v204/empleado/username/${encodeURIComponent(user.username)}`)
        .then((response) => {
          this.nombreEmpleado = response.data?.nombre || "";
        })
        .catch((error) => {
          console.error("Error al obtener el empleado:", error);
          const msg =
            error?.response?.data?.message ||
            "Error al obtener el empleado.";
          const dbg = error?.response?.data?.debugMessage || "";
          this.showMsgBoxConfirm(`${msg}${dbg ? " - Debug: " + dbg : ""}`, "danger", "Error");
        });
    },

    abrirObservacion(item) {
      this.item_observacion = item;
    },

    updateTotalProvisionado(importeProvisionado) {
      this.totalProvisionado = this.$parseDecimal(importeProvisionado);
    },

    onImporteProvisionadoCambiado(nuevoImporteProvisionado) {
      this.totalProvisionado = this.$parseDecimal(nuevoImporteProvisionado);
    },

    updateFacturarConsultor(item) {
      item.facturarConsultor = !item.facturarConsultor;
    },

    updateFacturado(item) {
      item.hitoFacturado = !item.hitoFacturado;
      this.totalFacturado = 0;
      for (let hito of this.hitosFacturacion) {
        if (hito.hitoFacturado) {
          this.totalFacturado += parseFloat(this.$parseDecimal(hito.importeHito));
        }
      }
      for (let avance of this.avance) {
        this.totalProvisionado = this.$parseDecimal(avance.importeProvisionado);
      }
    },

    updateFacturadoFinanciero() {
      this.totalFacturado = 0;
      for (let hito of this.hitosFacturacion) {
        if (hito.numFactura !== "") {
          this.totalFacturado += parseFloat(this.$parseDecimal(hito.importeHito));
        }
      }
      for (let avance of this.avance) {
        this.totalProvisionado = avance.importeProvisionado;
      }
    },

    addLineStopCriteria() {
      if ([2.5,5, 7.5, 10, 15, 20, 25, 30, 35, 40, 50, 60, 65, 70, 80, 90, 100].includes(Number(this.hitoFacturacion))) {
        this.importeHito = parseFloat(this.importeItem * (this.hitoFacturacion / 100)).toFixed(2);
      } else if (this.hitoFacturacion === "Desplazamiento") {
        this.importeHito = parseFloat(this.$parseDecimal(this.gastoViajeCoste)).toFixed(2);
      } else if (this.hitoFacturacion === "Certificacion") {
        this.importeHito = parseFloat(this.$parseDecimal(this.gastoCertificado)).toFixed(2);
      } else if (this.hitoFacturacion === "CosteImpresion") {
        this.importeHito = parseFloat(this.$parseDecimal(this.impresion)).toFixed(2);
      } else if (this.hitoFacturacion === "Formacion/Sesion") {
        this.importeHito = parseFloat(this.$parseDecimal(this.formacionSesion)).toFixed(2);
      } else if (this.hitoFacturacion === "Abono") {
        this.importeHito = parseFloat(this.$parseDecimal(this.abono)).toFixed(2);
      } else if (this.hitoFacturacion === "Bonificacion") {
        this.importeHito = parseFloat(this.$parseDecimal(this.gastoBonificacion)).toFixed(2);
      } else if (this.hitoFacturacion === "Consultoria/horas") {
        this.importeHito = parseFloat(this.$parseDecimal(this.importeConsultoriaHoras)).toFixed(2);
      } else if (this.hitoFacturacion === "AjusteFacturacion") {
        this.importeHito = parseFloat(this.$parseDecimal(this.importeAjusteFacturacion)).toFixed(2);
      }

      this.hitosFacturacion.push({
        hitoFacturacion: this.hitoFacturacion,
        importeHito: parseFloat(this.$parseDecimal(this.importeHito)).toFixed(2),
        facturarConsultor: this.facturarConsultor,
        fechaOKConsultor: this.fechaOKConsultor,
        hitoFacturado: this.hitoFacturado,
        fechaFacturado: this.fechaFacturado,
        gastoViajeCoste: this.$parseDecimal(this.gastoViajeCoste),
        gastoCertificado: this.$parseDecimal(this.gastoCertificado),
        gastoBonificacion: this.$parseDecimal(this.gastoBonificacion),
        numFactura: this.numFactura,
        abono: this.$parseDecimal(this.abono),
        formacionSesion: this.formacionSesion,
        observacion: "",
        liquidarNumeroDocumento: this.hitoFacturacion === "Abono" ? this.liquidarNumeroDocumento : null,
        facturaCobrada: this.facturaCobrada,
      });

   this.hitoFacturacion = "";
      this.gastoViajeCoste = 0;
      this.importeConsultoriaHoras = 0;
      this.gastoCertificado = 0;
      this.gastoBonificacion = 0;
      this.numFactura = "";
      this.abono = 0;
      this.formacionSesion = 0;
      this.observacion = "";
      this.importeAjusteFacturacion =0;
      this.impresion =0;
    },

    deleteLineStopCriteria(row) {
      const deletedItem = row.item;
      const index = this.hitosFacturacion.findIndex((h) => h === deletedItem);
      if (index === -1) return;

      const deletedHitoId = this.hitosFacturacion[index].id;
      this.hitosFacturacion.splice(index, 1);

      if (deletedHitoId) {
        api1
          .delete(`/api/dekra-projects/v204/facturacion/${deletedHitoId}`)
          .then((response) => {
            console.log("Hito eliminado en backend:", response.data?.message || "ok");
          })
          .catch((error) => {
            console.error("Error al eliminar el hito en el backend:", error);
          });
      }
    },

    seleccionarCheckboxDesplazamiento(event) {
      this.gastoDesplazamientoCosteCheck = event.target.checked;
    },
    seleccionarCheckboxBonificacion(event) {
      this.costeBonificacionCheck = event.target.checked;
    },
    seleccionarCheckboxCertificado(event) {
      this.gastoCertificadoCheck = event.target.checked;
    },

    ordenarPorFechaFacturacion() {
      this.hitosFacturacion.sort((a, b) => {
        const fechaA = new Date(a.fechaFacturado || "2100-01-01");
        const fechaB = new Date(b.fechaFacturado || "2100-01-01");
        return fechaA - fechaB;
      });
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    todoFacturar() {
      return this.hitosFacturacion.every(
        (hito) => hito.numFactura !== null && hito.numFactura !== ""
      );
    },
    hitosFacturacionOrdenados() {
      return [...this.hitosFacturacion].sort((a, b) => {
        const fechaA = new Date(a.fechaFacturado || "2100-01-01");
        const fechaB = new Date(b.fechaFacturado || "2100-01-01");
        return fechaA - fechaB;
      });
    },
    isAdminOrSuperAdmin() {
      const roles = this.$store.state.auth.user.roles || [];
      return roles.includes("ROLE_FINANCE") || roles.includes("ROLE_SUPERADMIN");
    },
    camposHitosFacturacion() {
      let baseFields = [...this.$constants().hitosFacturacionFields];
      const contieneAbono = this.hitosFacturacion.some((h) => h.hitoFacturacion === "Abono");

      baseFields = baseFields.filter((f) => f.key !== "liquidarNumeroDocumento");

      if (contieneAbono) {
        const indexNumFactura = baseFields.findIndex((f) => f.key === "numFactura");
        const nuevaColumna = {
          key: "liquidarNumeroDocumento",
          label: "Factura Liquidar",
          sortable: false,
          thStyle: { width: "230px", textAlign: "center" },
        };

        if (indexNumFactura !== -1) {
          baseFields.splice(indexNumFactura + 1, 0, nuevaColumna);
        } else {
          baseFields.push(nuevaColumna);
        }
      }
      return baseFields;
    },
    facturasDisponibles() {
      return this.hitosFacturacion
        .filter(
          (h) =>
            h.hitoFacturacion !== "Abono" &&
            h.numFactura &&
            h.numFactura.trim() !== ""
        )
        .map((h) => h.numFactura)
        .filter((value, index, self) => self.indexOf(value) === index);
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }
    this.getEmpleadoByUsername();
    this.ordenarPorFechaFacturacion();
  },
  created() {
    this.$root.$on("importeProvisionadoChange", this.updateTotalProvisionado);
  },
  beforeDestroy() {
    this.$root.$off("importeProvisionadoChange", this.updateTotalProvisionado);
  },
};
</script>

<style>
.custom-checkbox {
  width: 20px;
  height: 20px;
}

.b-form-datepicker {
  position: absolute;
  width: 230px;
}
</style>
